import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  PathPickOrderCancelRequestBody,
  pathPickOrderHistoryMutationApi,
} from "@/features/pathpick/features/order-history/api/mutation";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";

// 주문 취소(입금 전 전체 취소) — 성공 시 목록·상세를 한 번에 무효화한다
// (두 훅이 ["pathpick", "orders", companyId] 프리픽스를 공유한다).
// 성공 안내 UI와 모달 닫기는 호출부가 담당한다.
const useCancelPathPickOrder = (orderId: number) => {
  const { companyId } = useCompanyIdentity();
  const queryClient = useQueryClient();
  const { error } = useAppToasts({ id: "GLOBAL" });

  return useMutation({
    mutationFn: (body: PathPickOrderCancelRequestBody) =>
      pathPickOrderHistoryMutationApi.cancelPathPickOrder(
        companyId as number,
        orderId,
        body
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["pathpick", "orders", companyId],
      });
    },
    onError: (err) => {
      error(err);
    },
  });
};

export default useCancelPathPickOrder;
